import React, { useState, useEffect } from 'react';
import { ministryInfo, navigationItems } from '../mock';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const scrollToSection = (href) => {
    // Check if it's an external page link
    if (href.startsWith('/')) {
      window.location.href = href;
      return;
    }
    
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="navigation-header">
      <div className="container">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          <a href="#home" className="navigation-logo" onClick={(e) => {
            e.preventDefault();
            scrollToSection('#home');
          }}>
            {ministryInfo.name}
          </a>
          
          {/* Desktop Navigation */}
          <nav style={{ display: 'flex', alignItems: 'center' }}>
            <ul className="navigation-menu" style={{ display: isMobile ? 'none' : 'flex' }}>
              {navigationItems.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="navigation-link"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(item.href);
                    }}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
            
            {/* Mobile Menu Toggle */}
            <button
              className="btn-secondary"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              style={{ display: isMobile ? 'block' : 'none' }}
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </nav>
        </div>
        
        {/* Mobile Menu */}
        {isMenuOpen && isMobile && (
          <div className="mobile-menu" style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            backgroundColor: 'var(--bg-primary)',
            borderTop: '1px solid var(--border-light)',
            zIndex: 1000,
            padding: '20px 0'
          }}>
            <ul style={{ 
              listStyle: 'none', 
              padding: 0, 
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '15px'
            }}>
              {navigationItems.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="navigation-link"
                    style={{
                      display: 'block',
                      padding: '10px 20px',
                      textDecoration: 'none',
                      color: 'var(--text-primary)',
                      fontSize: '16px'
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(item.href);
                    }}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </header>
  );
};